<template>
	<div class="pageBox">
		<Header current='souye' ref="Header"></Header>
		<div class="pageBox_cen">
			<template v-for="(item,index) in list">
				<component :is="mapComponent[item.name]" :list='item' :ref="item.name" @goScroll='goScroll'/>
			</template>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/header.vue"
	import mapComponent from "@/components/mapComponent.js";
	import {
		get_banner,
	} from "@/api/index.js"
	import Footer from "@/components/footer.vue"
	export default {
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				mapComponent,
				list: [{
						name: 'aboutInvestBanner',
						value: '投资关系轮播图',
						list: [{
								img: require("@/assets/content/gyah.png"),
								name:'投资者关系'
							},
							{
								img: require("@/assets/content/gyah.png"),
								name:'投资者关系'
							},
						]
					},
					{
						name:'aboutInvestCen',
						value:'投资者关系内容'
					}
				],
				navHidden: false, // 导航栏是否隐藏
				lastScrollTop: 0, // 上一次页面滚动的位置
				currentRoute: '',
			}
		},

		mounted() {
			window.addEventListener('scroll', this.handleScroll);
			this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
			this.$watch('$route', this.onRouteChange);
			var element;
			if(this.nowVibe=='pc'){
				element= document.documentElement
			}else{
				element = document.documentElement.scrollTop ? document.documentElement : document.body;
			}
			let scrollTop = element.scrollTop;
			if (scrollTop == 0) {
				if(!this.$refs.Header.navHead){
					this.$refs.Header.headerHover = false;
				}
				this.$refs.Header.headerTrue = false;
			} else {
				this.$refs.Header.headerTrue = true;
				this.$refs.Header.headerHover = true;
			}
			this.getBannerList(16)
			let locale = this.$i18n.locale;
			if(locale!='zh'){
				this.$router.push('/')
			}
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);

		},
		methods: {
			goScroll(e){
				this.lastScrollTop=e;
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
					element.scrollTop =e+10;
				// document.documentElement.scrollTop = e+10;
			},
			onRouteChange(newRoute, oldRoute) {
				this.currentRoute = newRoute.path; // 更新当前路由地址
				this.$refs.aboutInvestCen[0].querValue = this.$route.query.value;
				// this.goScroll(this.$route.query.value)
			},
			handleScroll() {
				const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
					.scrollTop || 0;
				// if (currentScrollTop > this.lastScrollTop) {
				// 	this.navHidden = true;
				// } else {
				// 	this.navHidden = false;
				// }
				this.navHidden = true;
				this.lastScrollTop = currentScrollTop;
				this.$refs.aboutInvestCen[0].navHidden = this.navHidden;
				if (currentScrollTop == 0) {
					if(!this.$refs.Header.navHead){
						this.$refs.Header.headerHover = false;
					}
					this.$refs.Header.headerTrue = false;
				} else {
					this.$refs.Header.headerTrue = true;
					this.$refs.Header.headerHover = true;
				}
			},
			goScroll(e) {
				this.lastScrollTop = e;
				// document.documentElement.scrollTop = e + 10;
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
					element.scrollTop =e+10;
			},
			// 获取轮播图
			getBannerList(e) {
				let t = this;
				let data = {
					module: e
				}
			
				get_banner(data).then((res) => {
					console.log(res)
					this.$nextTick(function() {
						t.$refs['aboutInvestBanner'][0].setList(res.data);
					})
				}).catch((err) => {
					console.log(err)
				})
			},
		},
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.pageBox {
		display: flex;
		flex-direction: column;
		min-height: 100vh;

		.pageBox_cen {
			flex: 1;
		}
	}
</style>